import React, { Component } from 'react';
import { BrowserRouter, Route,  Navigate, Link } from 'react-router-dom'
import { ProgressSpinner } from 'primereact/progressspinner';
import Header from '../Header.js'
import LoginBox from "./../LoginBox.js";
import { Dialog } from "primereact/dialog";
import { connect } from "react-redux"
import Server from '../Server.js'
class VamPoint extends React.Component {     
  constructor(props){
    super(props);
    this.Server = new Server();
    this.state = {
      ShowLoading:true,
      response: []
    };

  }
  componentDidMount(){
    var param = '{CommandNo : "710" , AccountNo:  "' + this.props.username + '",Param1: "" }';
    let ip = this.props.ip || "https://ansar24.com";
    this.Server.sendRaymand("" + ip + "/MobileBank.aspx/MobileBankSp", param, (response)=>{
      let data = [];
      let resp = [];
      for (let i = 0; i < response.length; i++) {
        resp[i] = response[i].children;

      }
      this.setState({
        response: resp,
        ShowLoading: false
      })
    }, (error)=>{
      this.setState({
        ShowLoading: false
      })
    },{
      ip: this.props.ip
   })
  }
  ConvertNumToFarsi(text){
    if(!text)
      return text;
    var id= ['۰','۱','۲','۳','۴','۵','۶','۷','۸','۹'];
    return text.toString().replace(/[0-9]/g, function(w){
     return id[+w]
    });
  }
  Price(num){
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }
  render() {

    return (
      !this.state.ShowLoading ?
      <div style={{backgroundColor:'#fff',height:'100%'}}>      
        <div style={{direction:'rtl'}} >
        <div style={{display:'flex',justifyContent:'space-around',borderRadius:10,padding:10,margin:5,backgroundColor:'darkgray',color:'#fff'}} >
          <div style={{width:'30%', textAlign:'center'}}>تعداد قسط</div>
          <div style={{width:'70%', textAlign:'center'}}>مبلغ</div>
        </div>
        {this.state.response.map((resp, index)=>{
          const color = index % 2 ? 'aliceblue' : 'antiquewhite'
          return(
            <div style={{display:'flex',justifyContent:'space-around',borderRadius:10,padding:10,margin:5,backgroundColor:color}}>
                {resp.map((item)=>{
                  return(
                    item.name != "GstNo" ?
                    <div style={{width:'70%', textAlign:'center'}}>{
                      this.Price(item.value) 
                      } ریال</div>
                    :
                    <div style={{width:'30%', textAlign:'center'}}>{
                      item.value
                      }</div>
                  )
                })}
               

            </div>
          )
        })}
        </div>
        
        </div>

        :
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100%'}}>
          <ProgressSpinner style={{width: '50px', height: '50px'}} strokeWidth="2" fill="var(--surface-ground)" animationDuration=".5s"/>
            
          </div>  
      
          
        
    );
  }
}
function mapStateToProps(state) {
  return {
    username: state.username,
    password: state.password,
    ip: state.ip,
    account: state.account,
    place:state.place,
    fullname : state.fullname,
    tokenrb: state.tokenrb,
    mobile : state.mobile,
    Theme : state.Theme,
    appData:state.appData,
    creditPrice:state.creditPrice,
    systemId:state.systemId
  }
}
export default connect(mapStateToProps)(VamPoint)  
